import {
  REQUEST_UPGRADE_USER_SESSION,
  SUCCESS_UPGRADE_USER_SESSION,
  FAILURE_UPGRADE_USER_SESSION,
} from "../actions/ssoActions";

const initialState = {
  isUpgradeSessionFetching: false,
  isUpgradeSessionFetched: false,
  upgradeSessionSSOError: null,
};

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case REQUEST_UPGRADE_USER_SESSION: {
      return {
        ...state,
        isUpgradeSessionFetching: true,
        isUpgradeSessionFetched: false,
        upgradeSessionSSOError: null,
      };
    }

    case SUCCESS_UPGRADE_USER_SESSION: {
      return {
        ...state,
        isUpgradeSessionFetching: false,
        isUpgradeSessionFetched: true,
        upgradeSessionSSOError: null,
      };
    }

    case FAILURE_UPGRADE_USER_SESSION: {
      return {
        ...state,
        isUpgradeSessionFetching: false,
        isUpgradeSessionFetched: false,
        upgradeSessionSSOError: payload,
      };
    }

    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./reducers/ssoReducer.js